import api from '@/core/apiclient'
import {actionTypes} from '@/core/constants'

export default {
    async [actionTypes.ACESSO_SISTEMA.BUSCAR_ACESSOS_SISTEMAS]() {
        const {data} = await api.acessoSistema.buscarAcessosSistemas()
        return data
    }
}
